import React, { useEffect, useRef } from 'react';
import { useTheme } from '../theming/default_theme';
import { get } from '../api/apiService';
import FilterHospitalSideBar from './FilterHospitalSideBar';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Greeting from './Greeting';
import StatusBadge from './StatusBadge';
import { apiEndPoints } from '../api/apiEndPoints';
import spectacleRequestNotFound from '../assets/icons/no_spectacle_request_found.png'

const SpectacleRequests: React.FC<{ showModal: boolean, setShowModal: (value: boolean) => void, menuSelected: string }> = ({ showModal, setShowModal, menuSelected }) => {

	const theme = useTheme();
	const navigate = useNavigate();
	const [hospitalList, setHospitalList] = React.useState<any[]>([]);
	const [loading, setLoading] = React.useState(false);
	const [pageCount, setPageCount] = React.useState(1);
	const [pageCountIndex, setPageCountIndex] = React.useState(0);
	const [countPerPage, setCountPerPage] = React.useState(5);
	const [searchText, setSearchText] = React.useState('');
	const [showFilter, setShowFilter] = React.useState(false);
	const [allHospitals, setAllHospitals] = React.useState<any[]>([]);
	const [totalPages, setTotalPages] = React.useState(0);
	const [selectedCities, setSelectedCities] = React.useState<string[]>([]);
	const [selectedServices, setSelectedServices] = React.useState<string[]>([]);
	const [isFilterApplyClicked, setIsFilterApplyClicked] = React.useState(false);
	const [requestString, setRequestString] = React.useState<string>('');
	const tableRef = useRef<HTMLTableElement | null>(null);




	useEffect(() => {
		let newRequestString = `?page=${pageCount + pageCountIndex - 1}&size=${countPerPage}&searchString=${searchText.trim()}`;
		if (selectedCities.length > 0) {
			newRequestString += `&cities=${selectedCities.join(',')}`;
		}
		else { }

		if (selectedServices.length > 0) {
			newRequestString += `&services=${selectedServices.join(',')}`;
		}
		newRequestString += `&sort=name,asc`;

		setRequestString(newRequestString);
		console.log('Updated requestString:', newRequestString);
	}, [showModal, pageCount, pageCountIndex, countPerPage, isFilterApplyClicked, searchText]);

	// Fetch data whenever requestString changes
	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const url = `${apiEndPoints.hospitalFilterEndPoint}${requestString}`;
				console.log('Fetching data with requestString:', requestString);
				const response = await get(url);
				console.log('API Response:', response);
				const typedResponse = response as { content: any[] };
				setHospitalList(typedResponse.content || []);
				setTotalPages(response.totalPages || 0);
				setLoading(false);
			} catch (error) {
				console.error('Error fetching data:', error);
				setLoading(false);
			}
		};

		if (requestString) {

			fetchData();
		}
	}, [requestString]);

	useEffect(() => {
		setPageCount(1);
		setPageCountIndex(0);
	}, [selectedCities, selectedServices, searchText]);

	const handleSearchTextChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
		const searchText = event.target.value;
		console.log('Search Text:', searchText);
		setSearchText(event.target.value);
		setPageCount(1);
		setPageCountIndex(0);
		console.log('Search Text:', event.target.value);
	}

	const handlePageChange = async (event: React.MouseEvent<HTMLDivElement>) => {
		const page = event.currentTarget.innerText;
		console.log('page:', page);
		console.log('page.includesnext --:', page.includes('Next'));
		console.log('pageCount:', pageCount);
		console.log('pageCountIndex:', pageCountIndex);
		if (page.includes('Prev')) {
			if (pageCount == 1 && pageCountIndex === 0) {
				setPageCount(1);
				setPageCountIndex(0);
			}
			else {
				if ((pageCount % 5 === 1) && (pageCountIndex === 0)) {
					setPageCountIndex(4);
					setPageCount((prevPageCount) => prevPageCount - 5);
				}
				else {
					setPageCountIndex((prevPageCountIndex) => prevPageCountIndex - 1);
				}

			}

			console.log('pageCount:', pageCount);
			console.log('pageCountIndex:', pageCountIndex);
		}

		else if (page.includes('Next')) {
			console.log('you are in next')
			console.log('pageCount+pageCountIndex)%5==0:--', ((pageCount + pageCountIndex) % 5));
			if ((pageCount % 5 === 1) && (pageCountIndex === 4)) {
				setPageCountIndex(0);
				setPageCount((prevPageCount) => prevPageCount + 5);
			}
			else {
				setPageCountIndex((prevPageCountIndex) => prevPageCountIndex + 1);
			}
			console.log('pageCount:', pageCount);
			console.log('pageCountIndex:', pageCountIndex);
		}
		else {
			let pageIndex = (+page.trim()) - 1;   // Convert to number
			console.log('pageIndex:', pageIndex);
			setPageCountIndex(pageIndex % 5);
			setPageCount(Math.floor(pageIndex / 5) * 5 + 1);
			console.log('pageCount:', pageCount);
			console.log('pageCountIndex:', pageCountIndex);
		}

	}


	const handleHospitalClick = (hospital: { _id: string;[key: string]: any }) => {
		console.log('hospital clicked:', hospital);
		console.log('hospital._id:', hospital.id);
		const isSpectacleRequestScreen = true
		navigate(`/Landingpage/HospitalDetails/${hospital.id}`, { state: { hospital, isSpectacleRequestScreen } });
	}

	const exportTableToExcel = () => {
		const tableElement = tableRef.current;
		const workbook = XLSX.utils.book_new();
		const worksheet = XLSX.utils.table_to_sheet(tableElement);
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Spectacles List');
		const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
		saveAs(dataBlob, 'spectacle_list.xlsx');
	}


	return (
		<div className="flex flex-col h-full w-full border border-2 mt-2 overflow-hidden" style={{ backgroundColor: theme.colors.background }}>
			<Greeting />
			<div className="flex flex-row items-center pb-5">
				<div className="flex  flex-row justify-start items-center ml-[24px] mr-[20%]">Spectacles Requests</div>
				<input type="text" placeholder="Name, Hospital" className={`flex flex-row h-10 w-[40%] border border-[${theme.colors.surface}] rounded-full text-black pl-[10px] mr-10 placeholder:text-sm`} onChange={handleSearchTextChange} />
				<div className={`flex items-center justify-center w-[12%] h-10 bg-[${theme.colors.surface}] rounded-full text-white text-center text-sm cursor-pointer mr-2`} style={{ backgroundColor: theme.colors.surface }} onClick={() => setShowModal(true)}>
					Upload File
				</div>
				<div className={`flex items-center justify-center w-12 h-12 rounded-lg mr-2 ${(hospitalList && hospitalList.length > 0) ? 'cursor-pointer' : 'grayscale opacity-50 pointer-events-none'} transition`} onClick={exportTableToExcel}>
					<img src="/download.png" alt="download" className="w-12 h-12" />
				</div>
				<div className="flex items-center justify-center w-12 h-12 rounded-lg cursor-pointer transition mr-2" onClick={() => setShowFilter(!showFilter)}>
					<img src="/filter.png" alt="filter" className="w-12 h-12" />
				</div>
			</div>
			<div className={`relative flex  justify-start items-center ml-[24px]  w-[96%] h-full overflow-hidden`}>
				{(((pageCount + pageCountIndex) != 1) || (hospitalList && hospitalList.length > 0)) ? (
					<div className="flex flex-col w-full h-full">
						<div
							className={`flex justify-center items-center w-full h-[95%] border border-2 border-[${theme.borders.greyBorder}] rounded-[16px]`}
							style={{
								// overflowY: 'scroll',
								overflowX: 'hidden',
								borderRadius: 16,
								background: 'inherit',
								// boxSizing: 'content-box',
								backgroundColor: theme.colors.secondary,
								justifyItems: "start",
								alignItems: "start"
							}}
						>
							<table ref={tableRef} className="table-fixed h-full text-start border border-1" style={{ width: "100%", height: "100%", justifyItems: "start", alignItems: "start", justifyContent: "left", textAlign: 'left', fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightBold, fontSize: theme.typography.fontSize, color: theme.colors.text, borderRadius: 16, background: 'inherit' }}>
								<thead className="w-full  font-bold bg-[#F9F7ED] border border-1" style={{ borderBottomColor: theme.borders.color }}>
									<tr>
										<th className="w-[35%] text-start px-4 py-2">Hospital Name</th>
										<th className="w-[25%] text-start px-4 py-2">City & State</th>
										<th className="w-[30%] text-start px-4 py-2">Coordinator</th>
										<th className="w-[18%] text-center px-4 py-2">Total Referrals</th>
									</tr>
								</thead>
								<tbody className={`w-full text-start border border-[${theme.borders.color}]`} style={{ borderBottomColor: theme.borders.color }}>
									{(hospitalList.map((hospital: any, index: number) => (
										<tr key={index} className={`w-full text-start border border:theme.borders.color cursor-pointer`} onClick={() => handleHospitalClick(hospital)}>
											<td className={`w-full h-[10%] text-start   block align-top px-4 py-2`}>
												<span>{hospital.name}</span><br />
												<span className={`text-[${theme.colors.detailtext}]`} style={{ color: theme.colors.detailtext, fontWeight: theme.typography.fontWeightMedium }}>{hospital.address.address1}</span>
											</td>
											<td className="h-[18%] w-full align-top px-2 py-2">{hospital.address.city},{hospital.address.state}</td>
											<td className={`h-[10%] w-full text-start block  align-top px-4 py-2 text-wrap`}>
												<span>{hospital.coordinator}</span><br />
												<span className={`text-[${theme.colors.detailtext}]`} style={{ color: theme.colors.detailtext, fontWeight: theme.typography.fontWeightMedium }}>{hospital.coordinator_phonenumber}</span><br />
												<span className={`text-[${theme.colors.detailtext}]`} style={{ color: theme.colors.detailtext, fontWeight: theme.typography.fontWeightMedium }}>{hospital.coordinator_email}</span>
											</td>
											<td className="h-[10%] align-top px-4 py-2 text-center">{hospital.spectacleReferralCount}</td>
										</tr>
									)))}
								</tbody>
							</table>
							{showFilter && <FilterHospitalSideBar setShowFilter={setShowFilter} showFilter={showFilter} hospitalList={hospitalList} allHospitals={allHospitals} setAllHospitals={setAllHospitals} selectedCities={selectedCities} setSelectedCities={setSelectedCities} selectedServices={selectedServices} setSelectedServices={setSelectedServices} setIsFilterApplyClicked={setIsFilterApplyClicked} />}
						</div>
						<div className="flex flex-row items-center mt-10 gap-x-10 w-[30%] h-[10%] ml-[30%] justify-between">
							<div className={`${(pageCount + pageCountIndex - 1) != 0 ? 'flex items-center cursor-pointer' : 'flex items-center pointer-events-none opacity-50 cursor-not-allowed'}`} onClick={handlePageChange}>
								&laquo;Prev
							</div>
							{[0, 1, 2, 3, 4].map(i => (
								<div
									key={i}
									className={
										(pageCount + i <= totalPages)
											? (i === pageCountIndex
												? 'flex items-center justify-center cursor-pointer rounded-full bg-[#102A83] text-white'
												: 'flex items-center justify-center cursor-pointer')
											: 'flex items-center pointer-events-none opacity-50 cursor-not-allowed'
									}
									style={i === pageCountIndex ? { minWidth: 36, minHeight: 36 } : {}}
									onClick={handlePageChange}
								>
									{pageCount + i}
								</div>
							))}
							<div className={`${(pageCount + 5 <= totalPages) ? 'flex items-center cursor-pointer' : 'flex items-center pointer-events-none opacity-50 cursor-not-allowed'}`} onClick={handlePageChange}>
								<span>Next&raquo;</span>
							</div>
						</div>
					</div>

				) : (
					<div className="flex flex-col justify-center items-center w-full h-full">
						<div className="flex flex-col w-[50%] h-auto justify-center items-center overflow-visible rounded-[16px]">
							<img
								src={spectacleRequestNotFound}
								alt="no_spectacle_request_found"
								className="w-full h-auto object-contain"
							/>
						</div>
					</div>
				)}



			</div>

			{/* {showFilter && <FilterHospitalSideBar setShowFilter={setShowFilter} showFilter={showFilter} hospitalList={hospitalList} allHospitals={allHospitals} setAllHospitals={setAllHospitals} selectedCities={selectedCities} setSelectedCities={setSelectedCities} selectedServices={selectedServices} setSelectedServices={setSelectedServices} setIsFilterApplyClicked={setIsFilterApplyClicked} />} */}
		</div>

	);
}
export default SpectacleRequests;